import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import 'firebase/compat/firestore'
import { getStorage } from 'firebase/storage';
import { getFirestore } from 'firebase/firestore';
import 'firebase/compat/storage'
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyCHGLALXRavejSiOYMXuH3ithd-8buAnRo",
  authDomain: "done-2cd45.firebaseapp.com",
  projectId: "done-2cd45",
  storageBucket: "done-2cd45.appspot.com",
  messagingSenderId: "135010876263",
  appId: "1:135010876263:web:752a09959b8564ad968dc2"
};
  
  export const Firebase= firebase.initializeApp(firebaseConfig)
  export const auth = getAuth();   
  export const dbb = firebase.firestore();
  export const storage = getStorage();
  export const db = getFirestore();
 